import React from "react";

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-container">
        <div className="footer-brand">
          <span className="footer-logo">🚀</span>
          <span className="footer-title">Hacky Apps</span>
        </div>
        <div className="footer-links">
          <a href="/about">About</a>
          <a href="/pricing">Pricing</a>
          <a href="/contact">Contact</a>
        </div>
        <div className="footer-meta">
          <span>
            Made in NYC by friends who love code. &copy;{" "}
            {new Date().getFullYear()} Hacky Apps.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
